import { useParams } from "react-router-dom";
import PartnerNormalizationReviewWorkspace from "../../components/partner/inventory/PartnerNormalizationReviewWorkspace";

export default function PartnerDealerVehicleNamesPage() {
  const { dealerId } = useParams();
  return <PartnerNormalizationReviewWorkspace dealerId={dealerId} />;
}

export { PARTNER_NORMALIZATION_ISSUE_TYPES } from "../../components/partner/inventory/PartnerNormalizationReviewWorkspace";
